import './App.css';
import Featured from './components/Featured'
import Profile from './components/Profile';
import Project from './components/Project';
import Skills from './components/Skills';

import Navbar from './components/Navbar';
import Timeline from './components/Timeline';
import Education from './components/Education';
import Footer from './components/Footer';
import Dashboarding from './components/Dashboarding';
import { Analytics } from "@vercel/analytics/react"

function App() {

  return (
    <div id="parent-div">
        <Navbar />
        <Profile />
        <Dashboarding />
        <Skills />
        <Featured /> 
        <Timeline />
        <Project />
        <Education />
        <Footer />
        {/* <Analytics /> */}
    </div>
  );
}

export default App;
